export interface ClientAccountWebStoreConfig {
  backendURL: string;
  signInURL: string;
}

export abstract class ClientAccountWebStore {
  private static $config: ClientAccountWebStoreConfig;
  public static get config() {
    if (!this.$config) {
      throw new Error(`ClientAccountWebStore hasn't been initialized.`);
    }
    return this.$config;
  }

  public static init(config: ClientAccountWebStoreConfig) {
    this.$config = config;
  }
}
